var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "review-cart" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.productsInCart.length > 0 && _vm.webstoreContent
        ? _c(
            "div",
            { staticClass: "padding-bottom-4" },
            [
              _c("checkout-header", {
                attrs: {
                  categoryFilter: { display: false },
                  shoppingBag: { display: false },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col xs-12 md-10 md-offset-1 lg-6 lg-offset-3",
                    attrs: { id: "review-offers-in-cart-container" },
                  },
                  [_c("offers-in-cart", { attrs: { editable: false } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex flex-center align-center",
                  attrs: { id: "checkout-button-container" },
                },
                [
                  _vm.webstoreContent.continueToShipping
                    ? _c(
                        "button",
                        {
                          attrs: { id: "checkout-button" },
                          on: { click: _vm.submitHandler },
                        },
                        [_vm._v(_vm._s(_vm.webstoreContent.continueToShipping))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "subtotal" } }, [
                    _vm._v(
                      _vm._s(_vm.webstoreContent.subtotal) +
                        ": " +
                        _vm._s(_vm.currencySymbol) +
                        _vm._s(_vm.subtotal.toLocaleString("en-US"))
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }